import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Smart: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m450.73 540h-90.73v-30h90.73c12.44 0 24.45-5.12 32.93-14.06l21.41-22.54c14.12-14.87 34.05-23.4 54.68-23.4h25.25c8.28 0 15 6.72 15 15s-6.72 15-15 15h-25.25c-12.44 0-24.45 5.12-32.93 14.06l-21.41 22.54c-14.12 14.87-34.05 23.4-54.68 23.4z' />
    <path d='m630 420h-60.73c-20.63 0-40.56-8.53-54.68-23.4l-21.41-22.54c-8.48-8.93-20.48-14.06-32.93-14.06h-70.25v-30h70.25c20.63 0 40.56 8.53 54.68 23.4l21.41 22.54c8.48 8.93 20.48 14.06 32.93 14.06h60.73z' />
    <path d='m630 480h-70v-30h40c16.57 0 30 13.43 30 30z' />
    <path d='m690 420h-70v-30h40c16.57 0 30 13.43 30 30z' />
    <path d='m420 450h-120s0-30 0-30h90c16.57 0 30 13.43 30 30z' />
    <path d='m300 570h-75c-57.9 0-105-47.1-105-105s47.1-105 105-105v-30c-74.44 0-135 60.56-135 135s60.56 135 135 135h105c0-16.57-13.43-30-30-30z' />
    <path d='m659.9 360c-1.24-54.16-22.92-100.01-62.91-132.84-37.04-30.41-87.53-47.16-142.17-47.16-102.55 0-187.76 77.43-202.79 178.17-2.5 16.79 10.67 31.83 27.65 31.83 0-99.25 78.57-180 175.14-180 47.72 0 91.45 14.33 123.13 40.34 32.83 26.95 50.72 64.79 51.94 109.66z' />
  </IconBase>
));

Smart.displayName = 'Smart';

export default Smart;
